import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {

        const element = this.element
        element.addEventListener("click", () => {

            const video = element.querySelector(".video")

            if (element.classList.contains("video-playing")) {

                element.classList.remove("video-playing")
                video.innerHTML = "";
                return;
            }

            element.classList.add("video-playing")
            const videoUrl = video.getAttribute("data-src")
            video.innerHTML = `<video class="video-autoplay" autoplay muted loop playsinline preload="auto"><source src="${videoUrl}" type="video/mp4"></video>`
        })
    }
}
